export default function FloatingToolbar (pToolbar)
{
  const pThis = this;

  pThis.init = init;
  pThis.dispose = dispose;

  pToolbar.tWindow = pToolbar.tWindow || window;

  let floatingToolbarStructName,
      container,
      panel,
      panelContainer,
      panelContainerWidth = 0,
      panelContainerHeight = 0,
      isSizeInit = false,
      isPositionFixed = false,
      floatingToolbarCalculateSizeTM = null;


  function init (toolbarStructName)
  {
    const altScrollContainer = BEditor.window.getAltScrollContainer(pToolbar.tWindow);

    floatingToolbarStructName = toolbarStructName;
    render();

    BEditor.domHandlers.addHandler(pToolbar.tWindow, 'resize', calculatePosition);
    BEditor.domHandlers.addHandler(pToolbar.tWindow, 'scroll', calculatePosition);

    if (altScrollContainer)
    {
      BEditor.domHandlers.addHandler(altScrollContainer, 'resize', calculatePosition);
      BEditor.domHandlers.addHandler(altScrollContainer, 'scroll', calculatePosition);
    }

    floatingToolbarCalculateSizeTM = setTimeout(calculateSize, 100);

    return panelContainer;
  }


  function render()
  {
    const bgSpriteURL = BEditor.Config.getSpriteUrl('iconsSmall'),
          bgSprite = BEditor.Config.getSpriteByName('iconsSmall', floatingToolbarStructName);

    container = pToolbar.tDoc.createElement('DIV');
    container.setAttribute('id', 'idEditorFloatingToolbarContainer');
    container.setAttribute('style', 'position: absolute; left: 0px; top: 0px; z-index: 29737; visibility: visible; width: 73px; height: 37px; overflow: hidden;' + (floatingToolbarStructName === 'EditorPollDescriptionLocalToolbar' ? ' background-color: #F5F5F5;' : ''));
    container.innerHTML = '  <div id="idEditorFloatingToolbarPanel" style="position: absolute; left: 0; top: 0; z-index: 1; width: ' + bgSprite.width + 'px; height: ' + bgSprite.height + 'px; background: transparent url(' + bgSpriteURL + ') -' + bgSprite.icoOffsetX + 'px 0 no-repeat;">' +
      '  </div>' +
      '  <div id="idEditorFloatingToolbarPanelContainer" style="overflow: hidden; z-index: 3;"></div>' +
      '  <div id="idDropDownsHolder"></div>';

    pToolbar.editorToolbarContainer.appendChild(container);
    panel = BEditor.domHelpers.$('idEditorFloatingToolbarPanel', pToolbar.tWindow);
    panelContainer = BEditor.domHelpers.$('idEditorFloatingToolbarPanelContainer', pToolbar.tWindow);
  }


  function calculateSize ()
  {
    let tbContainerOffsetWidth,
        tbContainerOffsetHeight,
        editorToolbarParentOffsetWidth,
        panelContainerStyle,
        containerStyle,
        editorToolbarContainerStyle,
        editorToolbarParentStyle;

    if (pToolbar.tbContainer)
    {
      try
      {
        tbContainerOffsetWidth = pToolbar.tbContainer.offsetWidth;
        editorToolbarParentOffsetWidth = pToolbar.editorToolbarParent.offsetWidth;
        panelContainerStyle = panelContainer.style;
        containerStyle = container.style;
        editorToolbarContainerStyle = pToolbar.editorToolbarContainer.style;
        editorToolbarParentStyle = pToolbar.editorToolbarParent.style;
      }
      catch (err)
      {
        if (floatingToolbarCalculateSizeTM) clearTimeout(floatingToolbarCalculateSizeTM);
        return false;
      }

      if(panelContainerWidth !== tbContainerOffsetWidth  && panelContainerHeight !== editorToolbarParentOffsetWidth)
      {
        panelContainerWidth = (tbContainerOffsetWidth > editorToolbarParentOffsetWidth) ? tbContainerOffsetWidth : editorToolbarParentOffsetWidth - 2;
        panelContainerStyle.width = panelContainerWidth + 'px';
        containerStyle.width = panelContainerWidth + 'px';
        editorToolbarContainerStyle.width = (panelContainerWidth + 2) + 'px';
      }

      tbContainerOffsetHeight = pToolbar.tbContainer.offsetHeight;

      if (panelContainerHeight !== tbContainerOffsetHeight)
      {
        panelContainerHeight = tbContainerOffsetHeight;
        panelContainerStyle.height = panelContainerHeight + 'px';
        containerStyle.height = panelContainerHeight + 'px';
        editorToolbarContainerStyle.height = (panelContainerHeight + 1) + 'px';
      }

      if (!isSizeInit)
      {
        if (floatingToolbarStructName !== 'EditorPollDescriptionLocalToolbar')
        {
          editorToolbarContainerStyle.padding = '0';
          editorToolbarContainerStyle.border = '0';
          editorToolbarContainerStyle.border = 'none';
          editorToolbarContainerStyle.borderBottom = '1px solid #A2A6AB';
          editorToolbarContainerStyle.background = 'transparent';
          editorToolbarContainerStyle.backgroundImage = 'none';
          editorToolbarParentStyle.border = 'none';
        }

        editorToolbarContainerStyle.position = 'relative';
        calculatePosition();
        containerStyle.visibility = 'visible';
        isSizeInit = true;
      }
    }

    floatingToolbarCalculateSizeTM = setTimeout(calculateSize, 100);
  }


  function calculatePosition ()
  {
    const scrollLeft = BEditor.window.getScrollLeft(pToolbar.tWindow) + BEditor.window.getAltScrollLeft(pToolbar.tWindow),
          scrollTop = BEditor.window.getScrollTop(pToolbar.tWindow) + BEditor.window.getAltScrollTop(pToolbar.tWindow),
          componentFrame = BEditor.window.getAltScrollContainer(BEditor.environment.topWindow),
          editorToolbarContainerCoords = BEditor.dimensions.getElementXY(pToolbar.editorToolbarContainer, undefined, {container: componentFrame}),
          editorToolbarFixedContainerCoords = BEditor.dimensions.getElementXY(pToolbar.editorToolbarContainer, undefined, {container: BEditor.environment.topWindow.document.body});

    let isAnyEditorVisible = false;

    for (let editor of pToolbar.editorInstanceList)
    {
      let containerTop = componentFrame ? BEditor.dimensions.getElementXY(componentFrame).top : 0,
          editorCoords = BEditor.dimensions.getElementXY(editor.getEditorContainer());

      if (editorCoords.bottom - scrollTop - pToolbar.tbContainer.offsetHeight > containerTop)
      {
        isAnyEditorVisible = true;
        break;
      }
    }

    container.style.top = '0px';

    if (!BEditor.device.isIOS)
    {
      if (isAnyEditorVisible && (isEditorToolbarContainerVisible(editorToolbarContainerCoords) &&
          editorToolbarContainerCoords.top - scrollTop <= 0 &&
          (!BEditor.AdminPanel || !BEditor.environment.isCMSAdminMode || BEditor.isPageAdminViewMode())))
      {
        if (!isPositionFixed)
        {
          isPositionFixed = true;
          container.style.position = 'fixed';
        }

        container.style.left = (editorToolbarFixedContainerCoords.left - scrollLeft + (floatingToolbarStructName === 'EditorPollDescriptionLocalToolbar' ? 1 : 0)) + 'px';

        if (componentFrame)
        {
          container.style.top = BEditor.dimensions.getElementXY(componentFrame).top + 'px';
        }
      }
      else
      {
        container.style.left = '0px';
        container.style.top = '0px';

        if (isPositionFixed)
        {
          isPositionFixed = false;
          container.style.position = 'absolute';
        }
      }
    }
    else
    {
      if (editorToolbarContainerCoords.top - scrollTop <= 0 && (!BEditor.AdminPanel || !BEditor.environment.isCMSAdminMode || BEditor.isPageAdminViewMode()))
      {
        container.style.top = (scrollTop - editorToolbarContainerCoords.top) + 'px';
      }
      else
      {
        container.style.top = '0px';
      }
    }
  }


  function isEditorToolbarContainerVisible (coords)
  {
    let sum = 0;

    for (let k in coords)
    {
      if (coords.hasOwnProperty(k))
      {
        sum += parseInt(coords[k]);
      }
    }

    return !!sum;
  }


  function dispose ()
  {
    if (floatingToolbarCalculateSizeTM) clearTimeout(floatingToolbarCalculateSizeTM);
  }


  Object.defineProperty(this, 'floatingToolbarCalculateSizeTM', { get: () => floatingToolbarCalculateSizeTM, set: v => { floatingToolbarCalculateSizeTM = v }});
  Object.defineProperty(this, 'isPositionFixed', { get: () => isPositionFixed});
}